/** @format */
import ApiCollectionResponseInterface from '../api/ApiCollectionResponseInterface';

export default interface RateRangesCustomerSummaricInterface {
    id?: number | null;
    rateId: number | null;
    initial: string;
    price: string;
    threshold: string;
    interval: string;
    billsec: number;
}

export interface RateRangesCustomerSummaricCollectionInterface extends ApiCollectionResponseInterface {
    'hydra:member': Array<RateRangesCustomerSummaricInterface> | null;
}

export const RATE_RANGES_CUSTOMER_SUMMARIC_INITIAL: RateRangesCustomerSummaricInterface = {
    id: -1,
    rateId: -1,
    initial: '0.0000000000',
    price: '0.0000000000',
    threshold: '0.0000000000',
    interval: '0',
    billsec: 0,
};
